


















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ExpandablePreview extends Vue {
  heightViewport = 0
  heightCollapsed = 0
  heightOpen = 0
  collapsed = false
  over = false

  process = process

  get style () {

    if (process.env.PROD) return {}

    if (this.over) {
      return this.collapsed ? {
        'height': this.heightCollapsed + 'px',
        'overflow-y': 'hidden',
      } : {
        'height': this.heightOpen + 'px',
        'overflow-y': 'hidden',
        'padding-bottom': '36px'
      }
    } else {
      return {}
    }
  }

  get classes () {
    return this.collapsed ? '' : 'expandable-preview--open'
  }

  contentChanged () {
    // console.log('changed')
  }
}
